import {requestUrl, requestHeaders, requestOptions} from '../../graphQLClient.js'
import vueCookie from 'vue-cookie';

export default {

    getBaseData({commit, dispatch, state}){

        let requestQueryBody = {};
        requestQueryBody.operationName = null;

        requestQueryBody.query = `
                              {
                                sites(
                                       filters:{ status:ACTIVE},
                                       orderBy: {sort: "name", direction: "ASC"} 
                                      ) {
                                  edges {
                                    node {
                                      id
                                      name
                                      domain
                                      marketId
                                      status
                                    }
                                  }
                                }
                                partners(
                                          orderBy: {sort: "company", direction: "ASC"} 
                                        ) {
                                  edges {
                                    node {
                                      id
                                      company
                                      code
                                      type
                                      parentId
                                      status
                                      partners {
                                        id
                                      }
                                    }
                                  }
                                }
                                devices(orderBy: {sort: "id", direction: "ASC"} ) {
                                  edges {
                                    node {
                                      id
                                      type
                                      name
                                      groupId
                                    }
                                  }
                                } 
                                markets(orderBy: {sort: "name", direction: "ASC"} ) {
                                  edges {
                                    node {
                                      id
                                      name
                                      currency
                                      region
                                    }
                                  }
                                }
                              }
                             `;

        requestQueryBody.variables = null;

        let options = Object.assign({
            body: JSON.stringify(requestQueryBody),
            headers: requestHeaders
        }, requestOptions);

        return fetch(requestUrl, options).then(function(response){
            return response.json();
        }).then(function(data){
            return data.data;
        }).catch(function(error){
            return error;
        });
    },

    login({commit, dispatch, state}, credentials)
    {
        let requestQueryBody = {};
        requestQueryBody.operationName = null;

        let authHeader = 'Basic ' + btoa(credentials.login + ':' + credentials.password);
        requestHeaders.set('authorization', authHeader);

        requestQueryBody.query = `
                                {
                                  currentUser{
                                    id,
                                    firstName,
                                    lastName,
                                    email,
                                    online,
                                    allowedSites {
                                      id,
                                      name,
                                      domain
                                    },
                                    allowedPermissions {
                                      id,
                                      key,
                                      title
                                    },
                                    lastActivityDateTime
                                  }
                                }
                             `;

        requestQueryBody.variables = null;

        let options = Object.assign({
            body: JSON.stringify(requestQueryBody),
            headers: requestHeaders
        }, requestOptions);

        return fetch(requestUrl, options).then(function(response){
            if (response.status === 200)
            {
                commit('setAuthToken', authHeader);
                vueCookie.set('authToken', authHeader);

                return response.json();
            }
            else
            {
                return false;
            }
        }).then(function(data){
            return data.data;
        });
    },

    setAuthToken({dispatch, state, commit}, token)
    {
        commit('setAuthToken', token);
    },

    setUserData({dispatch, state, commit}, userData)
    {
        commit('setUserData', userData);
    },

    setAuthorizationStatus({dispatch, state, commit}, status)
    {
        commit('setAuthorizationStatus', status);
    },

    setSitesList({dispatch, state, commit}, value)
    {
        commit('setSitesList', value)
    },

    setPartnersList({dispatch, state, commit}, value)
    {
        commit('setPartnersList', value)
    },

    setMarketsList({dispatch, state, commit}, value)
    {
        commit('setMarketsList', value);
    },

    setDevicesList({dispatch, state, commit}, value)
    {
        commit('setDevicesList', value);
    },

    setLeftSideBarStatus({dispatch, state, commit}, value)
    {
        commit('setLeftSideBarStatus', value);
    },
    setScrollOffsetY({commit, state}, value){
        commit('setScrollOffsetY', value);
    },

    setURLParams({commit, state, dispatch}, params){
        commit('setURLParams', params);
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/base/actions.js